import * as Types from "../shared/Types";
import {getLevainTime} from "../shared/FermentationTiming";
import {
  calculateLevainFlourByTotalWeight,
  getPrefermentComponents,
  getPrefermentRefreshBuildComponents
} from "../dough/CalculatorUtils";

const newItems = {
  formName: '',
  formType: '',
  createdAt: '',
  modifiedAt: '',
  batchSize: 0,
  batchType: Types.BATCH_TYPE_TOTAL_WT,
  levain: {
    starterPct: 0,
    starterPctFraction: 0,
    hydrationPct: 0,
    hydrationPctFraction: 0,
    starterHydrationPct: 0,
    starterHydrationPctFraction: 0,
    starterWeight: 0,
    flourWeight: 0,
    flour: [],
    water: {weight: 0, percent: 0},
    levainFermPct: 0,
    levainFermTimeStr: '',
    totalWeight: 0,
    refresh1: {},
    refresh2: {}
  }
}

export function calculateLevainRecipe(inputData) {
  let items = JSON.parse(JSON.stringify(newItems))
  items.formName = inputData.formName
  items.formType = inputData.formType
  items.createdAt = inputData.createdAt
  items.modifiedAt = inputData.modifiedAt
  items.batchSize = inputData.batchSize
  items.batchType = inputData.batchType
  items.levain.starterPct = inputData.starterPct
  items.levain.starterPctFraction = inputData.starterPct / 100
  items.levain.hydrationPct = inputData.hydrationPct
  items.levain.hydrationPctFraction = inputData.hydrationPct / 100
  items.levain.starterHydrationPct = inputData.starterHydrationPct
  items.levain.starterHydrationPctFraction = inputData.starterHydrationPct / 100
  items.levain.levainFermPct = inputData.levainFermPct
  items.levain.levainFermTempF = inputData.levainFermTempF

  let levainEffFlourWeight = 0
  if (inputData.batchType === Types.BATCH_TYPE_FLOUR_WT) {
    levainEffFlourWeight = items.batchSize
  } else {
    levainEffFlourWeight = calculateLevainFlourByTotalWeight(items.batchSize, 0, items.levain.hydrationPctFraction, [])
  }
  const levainComponents = getPrefermentComponents(levainEffFlourWeight, items.levain.starterPctFraction, items.levain.starterHydrationPctFraction, items.levain.hydrationPctFraction)

  items = applyLevainComponentWeights(levainComponents.newFlourWt, levainComponents, inputData.levainFlour, items)
  items.levain.levainFermTimeStr = getLevainTime(items.levain.levainFermTempF, items.levain.levainFermPct, items.levain.starterPct, items.levain.hydrationPct)
  return items
}

function applyLevainComponentWeights(levainFlourWeight, levainComponents, levainFlourArray, items) {
  items.levain.starterWeight = levainComponents.seedWeight
  items.levain.flourWeight = levainComponents.newFlourWt
  items.levain.water.weight = levainComponents.newLiquidWt
  items.levain.water.percent = items.levain.hydrationPct
  items.levain.totalWeight = levainComponents.totalWt
  items.levain.flourEffectiveWeight = levainComponents.totalFlourWt

  // apply levain flour distribution
  levainFlourArray.forEach((fd) => {
    items.levain.flour.push({id: fd.id, name: fd.name, percent: fd.percent, weight: (Math.round(levainFlourWeight * (fd.percent / 100)))})
  })

  const refreshComp = getPrefermentRefreshBuildComponents(items.levain.totalWeight, 0,
          items.levain.starterPctFraction, items.levain.starterHydrationPctFraction, items.levain.hydrationPctFraction, [])

  items.levain.refresh1 = refreshComp.refresh1
  items.levain.refresh2 = refreshComp.refresh2

  return items
}
